/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { listLogsUserShot } from "../features/userSubscription/userSubscriptionSlice";
import { Input } from 'antd';
import { IoSearchOutline } from "react-icons/io5";

const LogsUserShot = () => {

  const [searchQuery, setSearchQuery] = useState('');

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 1000,
    key: '',
    status: ''
  });

  // Fetch data on component mount and pagination change
  useEffect(() => {
    const { current, pageSize, key } = pagination;
    const skip = (current - 1) * pageSize;
    dispatch(listLogsUserShot({ limit: pageSize, skip, key: key }));
  }, [dispatch, pagination.current, pagination.pageSize, pagination.key]);


  const { logsUserShot, total, isLoading } = useSelector((state) => state.userSubscriptions);

  const handleTableChange = (pagination) => {
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      total: total,
    }));
  }, [total]);

  const columns = [
    {
      title: "User",
      key: "user",
      render: (record) => {
        return (
          <div>
            <p>{record.user.first_name} {record.user.last_name}</p>
          </div>
        );
      }
    },
    {
      title: "Type",
      key: "type",
      render: (record) => {
        return (
          <div>
            <p>{record.type === 'hole-in-one'? 'Hole In One': 'Hole Out'}</p>
          </div>
        );
      }
    },
    {
      title: 'Date',
      render: (record) => {
        const date = new Date(record.createdAt);
        const formattedDate = date.toLocaleDateString('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
        const formattedTime = date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
        return `${formattedDate}, ${formattedTime}`;
      },
      key: 'createdAt',
    },
  ];

  // Handle key down events on search
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setPagination({
        ...pagination,
        current: 1,
        key: searchQuery,
      });
    }
  };

  return (
    <div>
      <div className="row-space-between">
        <h3 className="mb-4 title">Monitor Shot Clicks</h3>
        <div className="my-row">
          <div className="mr-5">
            <Input placeholder="Search users"
              value={searchQuery}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              prefix={<IoSearchOutline className="fs-4" />}
            />
          </div>
        </div>
      </div>
      <p> {isLoading} </p>
      <div>
        <Table
          columns={columns}
          dataSource={logsUserShot}
          rowKey={(record) => record._id}
          onChange={handleTableChange}
          pagination={pagination}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default LogsUserShot;
